module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAVtJREFUSEvV1a1LJHEYwPHPgsFw4YKCoqDRIHj3F1gNBk0WwXgeCBq0KVy4cHBFQUGwnGAxKVisFy674AlGBUFEg+HCBYM88AwMsis7i7vgA8PMMM/z/T3vU9MhqXWIq2vgEXxqM4o6rgvbssdzOEBPm+D/WMR+2BfgD7hP4Db+VYT3YgUBH4x7AR7HOS4xVQ6pxQOGcIrgfEa9AEdezxISp65jJz14jR1pW8Y3RNQhDcFXqdAXp2Z4v5uQJ7GLMTzmNdoMfIyv+In5BEZBV3GX7wMvvv/CGvYw8xp4NgHh0Wa230OmJz79wEf8zS74k/pHrYJDP6r9JWHxHBJhf8cWnkppqgQu7IYz/CjsBm4a5L0tcCtd9/7AJ5jOIbkoBiQKc5vFik6IXFaRGI6lNOiPlVBeQgvZ8EX1q4BDNzokev+wvIQKSEzORFVi6jddm23yGpt17Q/yZl4/A+MBUxdz9vLlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/u：envelope-alt.png
// module id = G85H
// module chunks = 5